// globals: jQuery

/**
 * I4goEMVTerminal
 *
 * @author Himanshu Rajput
 *
 * @param params
 * @constructor
 * @returns {I4goEMVTerminal}
 */
function I4goEMVTerminal(params) {
    this.params = params ? params : {};
}

/**
 * @description Connect EMV Terminal Request for Shift4
 * @param params
 * @param callback
 */
I4goEMVTerminal.prototype.callTerminal = function (params, callback) {
    var self = this;

    function runQuery(step) {
        self.callTerminalInProgress = true;
        jQuery.ajax({
            type: "GET",
            dataType: "jsonp",
            url: params.shift4LocalUtgUrl,
            timeout: 5000,
            success: function (data) {
                callback(data);
                self.callTerminalInProgress = false;
            },
            error: function () {
                if (step < 4) {
                    step++;
                    runQuery(step);
                } else {
                    self.callTerminalInProgress = false;
                    alert('Timeout');
                }
            }
        });
    }

    if (!this.callTerminalInProgress) {
        runQuery(0);
    }
};

export default I4goEMVTerminal;
